var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcademicIconBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9023 0.496094L40.5234 10.832C41.4258 11.3242 42 12.2266 42 13.2109C42 14.7695 40.6875 16 39.1289 16H2.78906C1.23047 16 0 14.7695 0 13.2109C0 12.2266 0.492188 11.3242 1.39453 10.832L20.0156 0.496094C20.5898 0.167969 21.3281 0.167969 21.9023 0.496094ZM21 4.51562L7.21875 12.0625H34.6992L21 4.51562ZM9.1875 18.625V31.75H14.4375V18.625H18.375V31.75H23.625V18.625H27.5625V31.75H32.8125V18.625H36.75V31.75H37.4062C38.4727 31.75 39.375 32.6523 39.375 33.7188C39.375 34.8672 38.4727 35.6875 37.4062 35.6875H4.59375C3.44531 35.6875 2.625 34.8672 2.625 33.7188C2.625 32.6523 3.44531 31.75 4.59375 31.75H5.25V18.625H9.1875ZM0 40.2812C0 39.2148 0.820312 38.3125 1.96875 38.3125H40.0312C41.0977 38.3125 42 39.2148 42 40.2812C42 41.4297 41.0977 42.25 40.0312 42.25H1.96875C0.820312 42.25 0 41.4297 0 40.2812Z",
    fill: "#3A8FD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademicIconBg);
export default __webpack_public_path__ + "static/media/academic-icon-bg.41a54d4e6b9e77630c152a7dd4297006.svg";
export { ForwardRef as ReactComponent };